import { render, staticRenderFns } from "./shouye.vue?vue&type=template&id=e956f5ee&scoped=true"
import script from "./shouye.vue?vue&type=script&lang=js"
export * from "./shouye.vue?vue&type=script&lang=js"
import style0 from "./shouye.vue?vue&type=style&index=0&id=e956f5ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e956f5ee",
  null
  
)

export default component.exports